import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from '@/store';
import { setDistributionSelectedCollection } from '@/slices/distribution';
import { useAutocompleteOptions } from '@features/standardDesign';
import StandardAutocompleteIdsWithFallback from '@features/standardDesign/components/autocomplete/StandardAutocompleteIds';

const DistributionIrrigationSelect = () => {
  const location = useLocation();
  const { data } = useAutocompleteOptions('icnCollections');
  const dispatch = useDispatch();
  const { selectedCollection } = useSelector((state) => state.distribution_store);
  useEffect(() => {
    if (data?.icnCollections?.length) {
      const [first] = data.icnCollections;
      dispatch(setDistributionSelectedCollection({ id: first.id, name: first.name }));
    }
  }, [data]);

  const show =
    location.pathname === '/distribution-initialization' ||
    location.pathname === '/distribution-history' ||
    location.pathname === '/distribution/canals';

  return (
    show && (
      <Box display={['none', 'flex', 'flex', 'flex']} width={{ xs: 200, sm: 300, md: 400 }} my={1}>
        <StandardAutocompleteIdsWithFallback
          fullWidth
          dataType="icnCollections"
          value={selectedCollection?.id ?? null}
          onChange={(_, value) => {
            const option = data?.icnCollections?.find((collection) => collection.id === value) ?? null;
            dispatch(
              setDistributionSelectedCollection(
                option ? { id: option.id, name: option.name } : null,
              ),
            );
          }}
          size="small"
        />
      </Box>
    )
  );
};

export default DistributionIrrigationSelect;
